<template>
	<div class="custom-step-counter text-center">
		<p class="font-blue"><b>{{ computedStepText }}</b></p>
		<span v-for="(step, $index) in steps" :class="{'bg-blue': process === step.key, 'bg-grey-cascade': process !== step.key}"></span>
	</div>
</template>
<script>
/**
 * Step Counter module is used to indicate the current step in a list of steps
 * @class StepCounter
 * @prop {array} steps - The steps to display in the counter
 * @prop {string} process - The name of the current step in the process
 * @since 0.0.7
 */

export default {
	name: 'step-counter',
	props: {
		steps: {
			type: Array,
			default: () => { return [] }
		},
		process: {
			required: true,
			type: String
		}
	},
	computed: {
		/**
		 * To compute the text that will display on the custom step counter each time the step changes
		 * @function
		 * @return {string} The text to display.
		 * @memberof StepCounter
		 * @version 0.0.7
		 */
		computedStepText () {
			let text = ''
			for (let i = 0, x = this.steps.length; i < x; i++) {
				if (this.process === this.steps[i].key) {
					text = (i + 1) + '. ' + this.steps[i].name
				}
			}
			return text
		}
	}
}
</script>
<style>
.custom-step-counter {
    position: absolute;
    width: 100%;
    bottom: 0px;
    padding-bottom: 25px;
    z-index: 5;
    padding-top: 25px;
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 10%, rgba(255,255,255,1) 100%);
    background: -o-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 10%, rgba(255,255,255,1) 100%);
    background: -ms-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 10%, rgba(255,255,255,1) 100%);
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 10%, rgba(255,255,255,1) 100%);
    left: 0px;
}
.custom-step-counter > p {
	margin-bottom: 10px;
}
.custom-step-counter > span {
	width: 14px;
    height: 14px;
    display: inline-block;
    border-radius: 50%;
    margin: 0px 10px;
}
</style>


// WEBPACK FOOTER //
// StepCounter.vue?50c99fe0